import { render } from "./DeleteIcon16.vue.js?vue&type=template&id=10359e48!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./DeleteIcon16.vue?vue&type=template&id=10359e48"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__